import LoginPage from "./LoginPage";

export default [
    {
        path: "/auth",
        name: "auth",
        component: LoginPage
    }
];